import React, { useContext } from 'react';
import styled from 'styled-components';
import { Loader } from '@mummssoftware/common-ui';
import { VisitLogContext } from '../../Context/VisitLogContext';
import { EditFaceToFace } from './EditFacetoFace';
import { EditTime } from './Timer/EditTime';
import EditDate from './Timer/EditDate';
import { DateWarningDialog } from './DateWarningDialog';
import { EditFees } from './EditFees';
import { EditVisitButtons } from './EditVisitButtons';

const EditVisitDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
`;

type EditVisitContentProps = {
  data: Record<string, any>;
  setClosed: () => void;
  onEdit: () => void;
  onRecord: () => void;
  isHopeVisit?: boolean;
};

export const EditVisitContent = ({
  data,
  setClosed,
  onEdit,
  onRecord,
  isHopeVisit,
}: EditVisitContentProps) => {
  const { showLoader } = useContext(VisitLogContext);
  return (
    <EditVisitDiv>
      {showLoader && <Loader />}
      <DateWarningDialog onRecord={onRecord} />
      {!isHopeVisit && <EditDate pastVisit={data} />}
      <EditTime pastVisit={data} />
      <EditFees pastVisit={data} />
      <EditFaceToFace data={data} />
      <EditVisitButtons setClosed={setClosed} onEdit={onEdit} />
    </EditVisitDiv>
  );
};
